import React from "react";
import { NotAcceptingOrdersBannerContent } from "./notAcceptingOrdersBannerContent";
import { Merchant } from "@/dto/merchant";
import { useTranslations } from "next-intl";
import { DayPart } from "@/dto/dayPartMenu";
import { HHMMtoDate } from "@/utils/dateTimeUtils";
import { isBusinessOpen } from "@/utils/isBusinessOpenUtil";
import { useSearchParams } from "next/navigation";
import { OrderType } from "@/types";
import { getMenuDisplayName } from "@/utils/dayPartMenuUtils";
import { findNextAvailableDay } from "@/utils/dayPartMenuUtils";
import { isNil } from "lodash";

export const NotAcceptingOrdersBanner = ({
  merchant,
  isNotAcceptingOrder = false,
  selectedDayPart = null,
}: {
  merchant: Merchant;
  isNotAcceptingOrder: boolean;
  selectedDayPart?: DayPart | null;
}) => {
  const t = useTranslations("NotAcceptingOrdersBanner");
  const searchParams = useSearchParams();
  const orderType = searchParams?.get("order_type");
  const isDineIn = orderType?.toLowerCase() === OrderType.DINE_IN.toLowerCase();
  if (!merchant) {
    return;
  }

  const isOpen = isBusinessOpen(merchant, isDineIn);

  const isActiveDayPartMenu = selectedDayPart?.activeNow ?? true;

  let dayPartStartTime = "";
  if (!isNil(selectedDayPart?.time?.startTime)) {
    dayPartStartTime = HHMMtoDate(
      selectedDayPart?.time?.startTime.toString().padStart(4, "0"),
      merchant.timezone,
      new Date()
    ).toLocaleString({
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }

  const nextAvailableDay = findNextAvailableDay(
    selectedDayPart,
    merchant.timezone
  );
  const message =
    isOpen && !isActiveDayPartMenu
      ? `${t("inActiveDayPart", {
          dayPartName: getMenuDisplayName(selectedDayPart?.menuName, t),
          dayPartStartTime: dayPartStartTime,
        })} ${nextAvailableDay ? `${t("on")} ${nextAvailableDay}` : ""}`
      : null;

  if (isNotAcceptingOrder) {
    return (
      <NotAcceptingOrdersBannerContent merchant={merchant} message={message} />
    );
  }

  return null;
};
